<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_diada') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.leftColumnExample)  }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}
            span(slot="value") {{ parameters.amountOfPairs }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.numOfExamples }}
        game-preview-setting(v-if="parameters.withTime")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_pairShowTime') }}
            span(slot="value") {{ parameters.showTime }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="settings.numbers.length !== 0")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}
            span(slot="value") {{ settings.numbers.join(', ') }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            gameName () {
                return this.parameters.withTime
                        ? this.$i18n.t('common.common_gameName_couplesWithTime')
                        : this.$i18n.t('common.common_gameName_couples');
            },
        }
    }
</script>
